import './App.css';
import { Helmet } from "react-helmet";
import { useState, useCallback, useEffect } from 'react';
import { isMobile, isAndroid, isDesktop, isIOS } from 'react-device-detect';

import { ClientJS } from 'clientjs';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import GooglePlay from './GooglePlay';
import Game from './Game';
import IOSPopup from './IOSPopup';
import CustomerServiceChat from './CustomerServiceChat';

function isGuestLoginUrl() {
  // var host = window.location.host;
  // console.log("host: " + host);
  // var guestlogin = host.includes("d29hnxc9z6usq4.cloudfront.net") || host.includes("vegasclub.cc");
  // console.log("guestlogin: " + guestlogin);
  // return guestlogin

  return false
}

function isRunningInPWA() {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
    return true;
  }
  return false;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

function generateUUID() {
  if (crypto && crypto.randomUUID) {
    console.log("use crypto.randomUUID");
    return crypto.randomUUID();
  } else {
    console.log("use uuidv4");
    return uuidv4();
  }
}

function initArguments() {
  if (isIOS) {
    localStorage.setItem("operating_system", "ios")
  } else if (isAndroid) {
    localStorage.setItem("operating_system", "android")
  } else {
    localStorage.setItem("operating_system", "pc")
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var pwa = urlParams.get('pwa')
  if (pwa == "1" || isRunningInPWA()) {
    localStorage.setItem("pwa", "1");
    var params = localStorage.getItem("params")
    if (params == null) {
      params = getCookie("params");
      if (params != null) {
        setCookie("params", params, 128);
      }
    }

    if (params == null) {
      localStorage.setItem("params", "{}");
    } else {
      var paramJson = JSON.parse(params)
      paramJson.pwa = "1"
      var jsonString = JSON.stringify(paramJson);
      localStorage.setItem("params", jsonString);
      if (paramJson.webUdid != null) {
        localStorage.setItem("web_uuid", paramJson.webUdid);
      }
    }
    console.log("pwa url");
    return;
  }

  var search = queryString.substring(1);
  if (search.length == 0) {
    console.log("empty params");
    localStorage.setItem("params", "{}");
  } else {
    var params = '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}';
    var paramJson = JSON.parse(params)
    var decodeSearch = decodeURI(search);
    localStorage.setItem("paramsString", decodeSearch);
    console.log("params string: " + decodeSearch);

    if (!isGuestLoginUrl()) {
      try {
        const client = new ClientJS()
        const fingerPrint = client.getFingerprint()
        paramJson.fingerPrint = fingerPrint
        console.log("client fingerPrint: " + fingerPrint)
      } catch (error) {
        console.error(error)
      }

      var uuid = localStorage.getItem("web_uuid")
      if (uuid == null) {
        uuid = generateUUID();
        localStorage.setItem("web_uuid", uuid)
      }

      paramJson.webUdid = uuid
      console.log("web uuid: " + uuid);
      params = JSON.stringify(paramJson)
    }

    console.log("params: " + params);
    localStorage.setItem("params", params)
    setCookie("params", params, 128);
  }
}

function App() {
  initArguments()
  var urlParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));
  var id = "655023419951738"

  function openGame() {
    const url = new URL(window.location.href);  // 获取当前页面的 URL 对象
    url.searchParams.delete("pwa");  // 删除指定参数
    // 使用 window.location.replace() 来跳转到新 URL
    window.location.replace(url.toString());  // 这将替换当前页面并更新 URL
  }

  const [isAndroidLanding, setAndroidLanding] = useState(false);
  const [isIOSLanding, setIsIOSPopupVisible] = useState(false);
  var pixelId = urlParams.get('pixelId')
  if (!pixelId) {
    localStorage.setItem("pixelId", "")
  } else {
    localStorage.setItem("pixelId", pixelId)
    id = pixelId
  }

  var way = urlParams.get('way')

  let s = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};"
    + "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');"
    + "fbq('init', '" + id + "');fbq('track', 'PageView');"
  let nos = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1"/>'

  let tt = '!function (w, d, t) {w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};'
    + "ttq.load('" + id + "');ttq.page();}(window, document, 'ttq');"

  function Head() {
    return <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="applcd e-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta http-equiv="Pragma" content="no-cache" />
      <meta http-equiv="Expires" content="0" />
      <script>
        {way == "tt" ? tt : s}
      </script>
      <noscript>
        {nos}
      </noscript>
    </Helmet>
  }

  useEffect(() => {
    // console.log(console.error.toString());
    // console.error("Test Sentry Error");
    var isLanding = JSON.parse(localStorage.getItem("params")).pwa == '0';
    if (isLanding && !isDesktop) {
      if (isIOS) {
        setIsIOSPopupVisible(true);
      } else {
        setAndroidLanding(true);
      }
    }
  })

  if (isGuestLoginUrl()) {
    try {
      const client = new ClientJS()
      const fingerPrint = client.getFingerprint()
      localStorage.setItem("web_uuid", fingerPrint)
      console.log("client fingerPrint: " + fingerPrint)
    } catch (error) {
      localStorage.setItem("web_uuid", "")
      console.error(error)
    }

    FingerprintJS.load()
      .then(fp => fp.get())
      .then(result => {
        const visitorId = result.visitorId
        localStorage.setItem("web_uuid", visitorId)
        console.log('visitorId: ', visitorId)
      })
      .catch(error => console.error(error))
  } else {

  }

  return (
    <div>
      {Head()}
      {isIOSLanding && <IOSPopup onClose={() => openGame()} />}
      {isAndroidLanding && <GooglePlay />}
      {!isAndroidLanding && !isIOSLanding && <Game />}
      {/* <CustomerServiceChat/> */}
    </div>
  )
}

export default App;
